import { Action, IAction } from './Action';

interface IActionsProps {
  actions: IAction[];
}

/**
 * -----------------------------------------------------------------------------
 * It renders a list of actions in header
 */
export function Actions({ actions }: Readonly<IActionsProps>) {
  return (
    <div className="ml-4 flex gap-2">
      {actions.map((item) => (
        <Action key={item.id} {...item} />
      ))}
    </div>
  );
}
